import { render, staticRenderFns } from "./LinkSuporte.vue?vue&type=template&id=6f399bf0&"
import script from "./LinkSuporte.vue?vue&type=script&lang=js&"
export * from "./LinkSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports